import { ORM } from './CouchORM2';

export default class RecurringAssessmentMapping extends ORM {
    static modelName = "RecurringAssessmentMapping";
}